export default {
  get_tipos: { method: "get", url: "api/traducoes-catalogo/tipos" },
  get_itens: {
    method: "get",
    url: "api/traducoes-catalogo/tipos{/tipo}/itens",
  },
  store: { method: "post", url: "api/traducoes-catalogo" },
  update: { method: "put", url: "api/traducoes-catalogo{/id}" },
  delete: { method: "delete", url: "api/traducoes-catalogo{/id}" },
};
